/* eslint-disable */
import axios from "../../common/cotAxios";
import {EditCaptionInfo} from "../../models/video";
import {LANGUAGE_JP} from "../../utils/Contants";

export default {
    // 辞書情報取得
    getAllContextPhrase(language: string): Promise<any> {
        return axios
            .get("/api/getContextPhrases", {params: {language: language}})
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // 辞書更新
    updateContextPhrase(language: string, phrases: string[]): Promise<string[]> {
        return axios
            .post("/api/updateContextPhrases", {language: language, phrases: phrases})
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // ビデオSTT編集
    EditVideoCaption(caption: EditCaptionInfo): Promise<any> {
        console.log("送信プロパティ→", caption);
        return axios
            .post("/api/updateTranscript", {
                captionId: caption.captionId,
                userId: caption.userId,
                beforeUpdateTranscript: caption.beforeUpdateTranscript,
                afterUpdateTranscript: caption.afterUpdateTranscript,
           })
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // ビデオSTT再実行
    RerunSTT(videoId: number, videoLanguage: string): Promise<any> {
        console.log("送信プロパティ→");
        console.log("videoId: ", videoId);
        return axios
            .post("/api/rerunSTT", {videoId: videoId, language: videoLanguage})
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // ビデオSTT公開ステータス更新
    UpdateCaptionPublicState(
        userId: number,
        videoId: number,
        publicCaption: boolean,
        muteState: boolean
    ): Promise<any> {
        console.log("送信プロパティ→");
        console.log("videoId: ", videoId, "publicCaption: ", publicCaption);
        return axios
            .post("/api/updateCaptionPublicState", {
                userId: userId,
                videoId: Number(videoId),
                videoSettings: [
                    {setting: "publiccaption", value: publicCaption},
                    {setting: "mute_audio", value: muteState},
                ],
           })
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // ビデオ処理情報取得
    getProcessStatus(userId: number): Promise<any> {
        return axios
            .get("/api/getProcessingVideoList", {params: {userId: userId}})
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // ビデオ処理情報取得（定期）
    getProcessStatusRepeat(userId: number): Promise<any> {
        return axios
            .get("/api/getProcessingVideoList", {params: {userId: userId}})
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // 統計情報取得
    getStatistics(startDate: string, endDate: string): Promise<any> {
        return axios
            .get("/api/getStatistics", {params: {startDate: startDate, endDate: endDate}})
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // 統計情報更新
    UpdateStatistics(
        userId: number,
        videoId: number,
        videoTag: string,
        videoTitle: string,
        videoUrl: string,
        viewDurationMillis: number,
        newWatch: boolean
    ): Promise<any> {
        return axios
            .post("/api/updateStatistics", {
                userId: userId,
                videoId: videoId,
                videoTag: videoTag,
                videoTitle: videoTitle,
                videoUrl: videoUrl,
                viewDurationMillis: viewDurationMillis,
                newWatch: newWatch,
           })
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },

    // 人気ランキング情報取得
    getPopularRanking(startDate: string, endDate: string): Promise<any> {
        return axios
            .get("/api/getPopularRanking", {params: {startDate: startDate, endDate: endDate}})
            .then(({data}) => data)
            .catch((error) => {
                return error;
           });
   },
};
